import enums from '@/mixins/enums';
import { DOCUMENT_STEP_ROUTER_NUMBER } from '@/config';

export default {
  mixins: [enums],
  methods: {
    /*
    * Method returns parsed model.
    * Also it will convert normal JS array to kotlin mutable list,
    * because kotlin validations don't know working with JS array.
    * */
    parseModel(model) {
      function createKotlinVisitedSteps(insuredPerson, index) {
        const { visitedSteps } = insuredPerson;
        model.insuredPersons.array_hd7ov6$_0[index].visitedSteps = kotlin.kotlin.collections.ArrayList_init_287e2$(); // eslint-disable-line
        model.insuredPersons.array_hd7ov6$_0[index].visitedSteps.array_hd7ov6$_0 = visitedSteps;
      }

      const { insuredPersons } = model;
      model.insuredPersons = kotlin.kotlin.collections.ArrayList_init_287e2$(); // eslint-disable-line
      model.insuredPersons.array_hd7ov6$_0 = insuredPersons;
      insuredPersons.forEach(createKotlinVisitedSteps);
      const { attachments } = model;
      model.attachments = kotlin.kotlin.collections.ArrayList_init_287e2$(); // eslint-disable-line
      model.attachments.array_hd7ov6$_0 = attachments;
      return this.$kotlin.model.Model_init_amxqw8$(model);
    },
    /*
    * Methods returns stringified model
    * */
    stringifyModel(model) {
      return JSON.stringify(model, (key, value) => {
        // If value is nationality/country return object
        if (value && !!value.area) return value;
        // If value is enumeration return only value
        if (value && !!value.name$) return value.name$;
        return value;
      });
    },
    async saveLead(nextStep, type = 'UZP', saveLater = false) {
      try {
        this.model.currentPersonStepIndex += 1;
        const pureModel = JSON.parse(JSON.stringify(this.model));
        this.model.currentPersonStepIndex -= 1;
        pureModel.step = nextStep;
        pureModel.lastStep = pureModel.lastStep > nextStep ? pureModel.lastStep : nextStep;
        const {
          insurer, leadUuid, step, saveResponse, broker,
        } = pureModel;

        const request = {
          phone: insurer.phone,
          email: broker.email ? broker.email : insurer.email,
          json: this.stringifyModel(pureModel),
          leadHash: leadUuid,
          variabilnySymbol: saveResponse.cislo,
          step,
          type,
          saveLater,
        };

        const { DistributionChannelEnum } = this.enums;
        if (this.model.distributionChannel === DistributionChannelEnum.VIP) {
          request.distributionChannel = DistributionChannelEnum.VIP.name$.toLowerCase();
        }

        const response = await this.$axios.post('/uzp_api/japi/IUzpApi/saveLead', [request]);
        if (!this.model.leadUuid) {
          this.funnelLead(response.data);
        }
        this.model.leadUuid = response.data;
      } catch (e) {
        console.log(e);
      }
    },
    async loadLead(uuid) {
      try {
        const response = await this.$axios.get(`/uzp_api/japi/IUzpApi/loadLead?id=${uuid}`);
        const parsedLead = JSON.parse(response.data);
        this.model = this.parseModel(JSON.parse(parsedLead));
        this.model.saveForLaterLeadUuid = uuid;
        this.model.attachments.array_hd7ov6$_0.length = 0;
        await this.$store.dispatch('getContactPlaces');
        this.setEnumsLabels();
        // const { InsuredPersonTypeEnum: options } = this.enumsValues;

        this.$nextTick(() => {
          if (this.personsWithRequiredAttachments.length) {
            this.$store.commit('SET_LOADED_FROM_SAVE_FOR_LATER', true);
            if (this.model.step > DOCUMENT_STEP_ROUTER_NUMBER) {
              this.$router.goToStep(DOCUMENT_STEP_ROUTER_NUMBER);
            } else {
              this.$router.goToStep(this.model.step);
            }
            return;
          }

          if (this.model.step === 21 && this.model.eid?.leadNotificationSent) {
            // this.$router.maxStep = 11;
            // this.$router.push({ name: 'EIDIntro', query: this.$route.query });
          } else {
            this.$router.goToStep(this.model.step);
          }
        });
      } catch (err) {
        console.log(err);
      }
    },
  },
};
